<template>
  <div class="p-0 m-0"> 
    <div class="text-input">
      <label><b>{{label}}</b></label>
      <div @click="toggleCustomerSearchModal" class="pointer input-group">
        <input 
          :type="type"
          class="form-control pointer" 
          :disabled="disabled"
          :placeholder="placeholder"  
          :style="customStyles"
          v-model="displayText"
          @input="updateValue" 
          :aria-label="{label}">
          <div class="input-group-append pointer">
            <span class="input-group-text"><i class="fa fa-search" title="customer-search"  aria-hidden="true"></i></span>
          </div>
      </div>
    </div>
    
      <CustomerComboboxSearch
        ref="customerSearchDropdown"
        @customerSelected="customerSelected"
        :value="currentCustomer.JdeNum"
        @toggleAddCustomerModal="toggleAddCustomerModal"
      />
    <!-- <Modal ref="customerSearchModal">
      <div class="card modal-card">
        <h5>Advanced Customer Search</h5>
        <hr>
        <BasicDataGrid 
            :dataSource="customers" 
            :columns="columns" 
            headerFontSize="10px"
            cellFontSize="8px"
            :searchByColumn="false"
            :advancedFilter="false"
            :filterByColumn="false"
            height='200px'
            :showColumnLines="true"/>
        <button type="button" class="btn btn-primary" @click="toggleAddCustomerModal">Add New Customer</button>
      </div>
    </Modal> -->
    <Modal ref="privateCustomerFormModal">
      <PrivateCustomerForm v-model="newCustomer" @privateCustomerSaved="privateCustomerSaved" @cancelPrivateCustomer="toggleAddCustomerModal" :editingCustomer="false"/>
    </Modal>
  </div>
</template>

<script>
import Modal                    from './Modal';
import BasicDataGrid            from './BasicDataGrid';
import CustomerComboboxSearch   from './CustomerComboboxSearch';
import PrivateCustomerForm      from './PrivateCustomerForm';

import { CustomerService }         from '@/services';

export default {
  name: "AdvancedCustomerSearch",
  components:{
    BasicDataGrid,
    CustomerComboboxSearch,
    PrivateCustomerForm
  },
  props: {
     label: {
        type: String,
     },
     readOnly: {
       type: Boolean,
       default: false
     },
     placeholder: {
        type: String,
     },
     disabled: {
        type: Boolean,
        default: false,
     },
     value: {
        type: Object,
        default: () => {}
     },
     type: {
        type: String,
        default: 'text'
     },
     customStyles: {
         type: Object,
     }
  },
  data(){
    return{
      displayText: null,
      loading: false,
      currentCustomer: {},
      newCustomer: {
        Id: 0,
        JdeNum: '',
        Name: '',
        LicenseNumber: null,
        Specialty: null,
        PhoneNum: '',
        FaxNum: '',
        CustomerContact: {
          FirstName: '',
          LastName: '',
          PhoneNumber: '',
          Email: null,
        },
        Address: {
          AddressId: 0,
          Name: '',
          Line1: '',
          Line2: '',
          City: '',
          StateId: 0,
          ZipCode: '',
          LocationCode: '',
        },
        IsPrivate: true
      },
      // customers: [],
      columns: [
        {text: 'ID', value: 'Id'}, 
        {text: 'Code', value:'Code'}, 
        {text: 'Title', value:'Title'},
        {text: 'First Name', value:'Name'}, 
        {text: 'Last Name', value:'LastName'}, 
        {text: 'Location', value:'Location'},
        {text: 'Email', value:'Email'}, 
        {text: 'City', value:'City'}, 
        {text: 'State', value:'State'}, 
        {text: 'Zip', value:'Zip'},
        {text: 'Status', value:'IsPrivate'},
      ],
    }
    
  },
  methods:{
    updateValue(){
      this.$emit("input", this.currentCustomer);
    },
    customerSelected(customer){
      this.currentCustomer = customer;
      this.displayText = customer.JdeNum;
      
    },
    toggleCustomerSearchModal(){
      if(this.readOnly) return;
      this.$refs.customerSearchDropdown.toggle()
    },

    toggleAddCustomerModal(){
      this.$refs.privateCustomerFormModal.toggle()
    },
    privateCustomerSaved(customer) {
      // this.newCustomer.BillingAddress= this.newCustomer.Address
      console.log('customer saved', customer)
      this.currentCustomer = customer
      this.displayText = this.newCustomer.JdeNum // will be JdeNum
      this.toggleAddCustomerModal( )
      this.toggleCustomerSearchModal()
      this.getCustomers()
    },
    // getCustomers(){
    //   this.loading = true
    //   CustomerService.all().then(response => {
    //     this.customers = response
    //   }).catch(err => {
    //     console.log(err)
    //   }).finally(() => {
    //     this.loading = false 
    //   })
    // }
  },
  watch: {
    currentCustomer: function(){
      this.$emit("input", this.currentCustomer);
      this.$emit('change')
    },
    value: function(){
      this.displayText = this.value.JdeNum;
    }
  },
  created(){
    this.displayText = this.value.Name;
    // this.getCustomers();
  }
}
</script>

<style lang="scss" scoped>
  
  .pointer{
    cursor: pointer;
  }
</style>